import { TipoDependente, GrupoCoparticipacao } from '../models';

export const MOCK_DASHBOARD_DEPENDENTES = {
  totalDependentes: 8904,
  totalSaudeAtiva: 7120,
  dependentesPorTipo: [
    { tipoDependente: TipoDependente.CONJUGE, quantidade: 2914 },
    { tipoDependente: TipoDependente.COMPANHEIRO, quantidade: 962 },
    { tipoDependente: TipoDependente.FILHO, quantidade: 4300 },
    { tipoDependente: TipoDependente.ENTEADO, quantidade: 388 },
    { tipoDependente: TipoDependente.PAI, quantidade: 110 },
    { tipoDependente: TipoDependente.MAE, quantidade: 108 },
    { tipoDependente: TipoDependente.EX_CONJUGE, quantidade: 64 },
    { tipoDependente: TipoDependente.TUTELADO, quantidade: 36 },
    { tipoDependente: TipoDependente.MENOR_SOB_GUARDA, quantidade: 22 }
  ],
  origemCadastro: {
    importadosSirc: 7924,
    cadastradosManualmente: 980
  },
  alertasAnomalias: [
    {
      tipoAlerta: 'FALTA_DOCUMENTO_CIVIL',
      descricao: 'Cônjuge ativo na saúde sem certidão de casamento ou escritura de união estável cadastrada.',
      pessoaId: 'd-101',
      nomeDependente: 'Ana Maria de Souza',
      titularMatricula: 'PM.2015.000214'
    },
    {
      tipoAlerta: 'UNIVERSITARIO_SEM_COMPROVANTE',
      descricao: 'Filho maior de 21 anos (23 anos) sem comprovante de matrícula em curso superior ativo.',
      pessoaId: 'd-102',
      nomeDependente: 'Pedro Silva Souza',
      titularMatricula: 'PM.2010.000102'
    },
    {
      tipoAlerta: 'INVALIDO_SEM_LAUDO',
      descricao: 'Filho inválido cadastrado na saúde sem laudo médico ativo ou com prazo expirado.',
      pessoaId: 'd-103',
      nomeDependente: 'Rodrigo Medeiros Costa',
      titularMatricula: 'PM.1998.000842'
    },
    {
      tipoAlerta: 'DUPLICIDADE_CONJUGE',
      descricao: 'Múltiplos cônjuges/companheiros ativos associados ao mesmo titular.',
      pessoaId: 'd-104',
      nomeDependente: 'Mariana Pires Ramos',
      titularMatricula: 'PM.2005.000342'
    },
    {
      tipoAlerta: 'DECISAO_JUDICIAL_SEM_PROCESSO',
      descricao: 'Ex-cônjuge mantido na saúde por decisão judicial sem número de processo ou documento liminar anexado.',
      pessoaId: 'd-105',
      nomeDependente: 'Cláudia Regina Fonseca',
      titularMatricula: 'PM.2002.000788'
    }
  ],
  previsoesDesligamento: {
    proximos30Dias: 18,
    proximos60Dias: 42,
    proximos90Dias: 86,
    detalhes: [
      {
        pessoaId: 'd-111',
        nomeDependente: 'Gabriel Barbosa Silva',
        dataPrevisaoDesligamento: '2026-07-01',
        motivo: 'Completa 21 anos (requer comprovante universitário)'
      },
      {
        pessoaId: 'd-112',
        nomeDependente: 'Juliana Costa Nunes',
        dataPrevisaoDesligamento: '2026-07-15',
        motivo: 'Completa 24 anos (limite máximo de idade)'
      },
      {
        pessoaId: 'd-113',
        nomeDependente: 'Mateus Pereira Lima',
        dataPrevisaoDesligamento: '2026-07-20',
        motivo: 'Expiração da validade do laudo médico temporário'
      },
      {
        pessoaId: 'd-114',
        nomeDependente: 'Camila Rodrigues Alves',
        dataPrevisaoDesligamento: '2026-08-10',
        motivo: 'Comprovante de matrícula universitária vencido'
      }
    ]
  }
};
